import Vue from 'vue'

export function empresa_nombre(state) {
    return Vue.$cookies.get('empresa_name');
}
export const empresa_version = (state) => {
    if (state.empresa && state.empresa.version) {
        return state.empresa.version;
    }
    return '1.0';};

export function get_pedidos_pendientes(state) {
    return state.pedidos_pendientes
}

//PEDIDO COMPRA

export function detalles_pedido_compra(state) {
    return state.pedido_compra_register.detalle_pedido
}

export function proveedor_select_pedido_compra_register(state) {
    return state.pedido_compra_register.proveedor
}


//PEDIDO VENTA
export function detalles_pedido_venta(state) {
    return state.pedido_venta_register.detalle_pedido
}
export function formCliente(state) {
    return state.pedido_venta_register.cliente
}
export function formEnvio(state) {
    return state.pedido_venta_register.envio
}
 ///////




 






